export { XpmConnectionIllustration } from './XpmConnectionIllustration';
export type {
  XpmConnectionIllustrationVariant,
  XpmConnectionIllustrationProps,
} from './XpmConnectionIllustration';
